import React,{useState,useEffect} from "react";
import Convert from "./translator.js";

function FetchQuote() {
    const [quote,setQuote] = useState('');
    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        getQuote();
       const intervalID = setInterval(()=>{
        getQuote()
       }, 24 * 60 * 60 * 1000);
    return ()=>{
        clearInterval(intervalID);
    }
    },[])
    function getQuote() {
        fetch('https://api.adviceslip.com/advice')
        .then(res=> res.json())
        .then(data=>{
            console.log(data);
            setQuote(data.slip.advice);
            setLoading(false);
        })
        .catch( error =>{
            console.log(error);
            setQuote("No predigas tu futuro; simplemente créalo.");
            setLoading(false);
            
        })
    }
return(
    <>
        <label class="mainTitle">
            { 
                loading? "Cargando..." : <Convert text={quote} language="es"/>
            }
        </label>

    </>
)
}
export default FetchQuote